import { SelectOption } from '../models/select.model';

export enum Supplier {
  OTHER = 'Other',
  PREM = 'Premier Inn',
  TLODGE = 'Travelodge',
  AMADEUS = 'Amadeus',
  BCOMNOW = 'Booking.com NOW',
  BCOM = 'Booking.com',
  XHOTEL = 'XHotel',
  BCOMVCC = 'Booking.com VCC',
  EAN = 'Expedia',
  EANPKG = 'Expedia Package',
  EANVCC = 'Expedia VCC',
  GALILEO = 'Galileo',
  HB = 'HotelBeds',
  TPORT = 'Travelport',
}

export const supplierSelectOptions: SelectOption[] = Object.keys(Supplier).map((supplier: string) => ({
  label: Supplier[supplier],
  value: supplier,
}));
